import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { ChoixLangueCertificatDialogComponent } from '../contenus-management/contenus-complete/choix-langue-certificat-dialog/choix-langue-certificat-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { ContenuSessionService } from 'src/services/contenu.session.service';
import { ContenuSessionModel } from 'src/models/contenuSessionModel';
import { MatSelectModule } from '@angular/material/select';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatButtonModule } from '@angular/material/button';
import { TiretPipe } from 'src/app/pipe/tiret.pipe';
import { OrganisationModel } from 'src/models/pilotage/organisationModel';
import { InfosCertificatModel } from 'src/models/Session/infos-certificat-model';
import { EtiquetteService } from 'src/services/etiquette.service';
import { EtiquetteSessionModel } from 'src/models/etiquetteSessionModel';
import { MatDatepickerModule, MatDateRangePicker } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomPaginatorIntlService } from 'src/services/custom-paginator-intl.service';
import { StringHelpers } from 'src/models/helpers/string-helpers';
import moment from 'moment';

@Component({
    selector: 'app-certificat-managment',
    imports: [
        MatIcon,
        CommonModule,
        MatProgressSpinner,
        MatSelectModule,
        TranslateModule,
        FormsModule,
        MatCheckboxModule,
        MatFormFieldModule,
        NgxMatSelectSearchModule,
        ReactiveFormsModule,
        MatPaginator,
        MatTableModule,
        MatSortModule,
        MatButtonModule,
        TiretPipe,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTooltipModule
    ],
    providers: [
        {
            provide: MatPaginatorIntl,
            useClass: CustomPaginatorIntlService
        }
    ],
    templateUrl: './certificat-managment.component.html',
    styleUrls: ['./certificat-managment.component.scss']
})
export class CertificatManagmentComponent implements OnInit {
  @ViewChild('picker') picker!: MatDateRangePicker<Date>;

  momentDate = moment;
  dateDebut!: Date | undefined;
  dateFin!: Date | undefined;

  showGroupe: boolean = false;
  isCheckAll!: boolean;
  contenuCertificats: ContenuSessionModel[] = [];
  isLoading: boolean = false;
  certificats: InfosCertificatModel[] = [];
  contenuCertificatsAffiches: ContenuSessionModel[] = [];
  contenuCertificatsFiltreEnCours: ContenuSessionModel[] = [];
  contenuSessionModels: ContenuSessionModel[] = [];
  selectionGroupe: string = "";
  selectionCertificat: string = "";
  selectionOrganisation: string = "";
  selectionTitreContenu: string = "";
  selectionEtiquette: string = "";
  selectionDateAcces: string = "last30days";
  textRechercher: string = "";

  etiquettes: EtiquetteSessionModel[] = [];
  groupeIdsSelection: string[] = [];
  organisationIdsSelection: string[] = [];
  etiquetteIdsSelection: string[] = [];
  contenusSelection: string[] = [];

  groupes: OrganisationModel[] = [];
  organisations: OrganisationModel[] = [];
  titres: string[] = [];

  etiquetteFilterCtrl: FormControl = new FormControl();
  groupFilterCtrl: FormControl = new FormControl();
  orgFilterCtrl: FormControl = new FormControl();
  titreFilterCtrl: FormControl = new FormControl();

  filteredEtiquettes: ReplaySubject<EtiquetteSessionModel[]> = new ReplaySubject<EtiquetteSessionModel[]>(1);
  filteredOrganisations: ReplaySubject<OrganisationModel[]> = new ReplaySubject<OrganisationModel[]>(1);
  filteredGroupes: ReplaySubject<OrganisationModel[]> = new ReplaySubject<OrganisationModel[]>(1);
  filteredTitres: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);


  _onDestroy = new Subject<void>();

  displayedColumns: string[] = [
    'dateComplete',
    'organisation',
    "etiquettes",
    'prenomNom',
    'titre',
    "estDonneCertificat",
    "actions"
  ];

  entiteId!: number;
  pageIndex: number = 0;
  pageSize: number = 10;
  currentPage: number = 0;
  totalItems: number = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  textFilter: string = '';
  afficherSpinner: boolean = true;
  isFiltering: boolean = false;

  dataSource!: MatTableDataSource<ContenuSessionModel>;

  @ViewChild('checkboxSelected') checkboxSelected!: ElementRef<HTMLInputElement>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private dialog: MatDialog,
    public etiquetteService: EtiquetteService,
    private utilisateurServicePilotage: UtilisateurService,
    private contenuSessionService: ContenuSessionService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.dataSource = new MatTableDataSource<ContenuSessionModel>([]);
  }

  ngOnInit() {
    this.initializeDefaultDates();
    this.obtenirContenusSessionsRole();
    if (this.estShowGroupeColumn) {
      this.displayedColumns.splice(1, 0, 'groupe');
    }
    this.bindFiltredCtl();
  }

  ngAfterViewInit() {
    if (this.sort) {
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      this.totalItems = this.contenuCertificats.length;
      this.refreshDataSource();
    }
  }

  onDateChange() {
    if (this.dateDebut && this.dateFin) {
      this.picker.close();
      this.filtreDateAcces();
    }
  }

  onModeCustomDate() {
    setTimeout(() => this.picker.open(), 200);
  }

  resetSelectCustumDate() {
    this.dateDebut = undefined;
    this.dateFin = undefined;
  }

  get estShowGroupeColumn(): boolean {
    return this.utilisateurServicePilotage.selectionEntiteUtilisateur.estRoot || this.utilisateurServicePilotage.estRolePiloteOuAdmin();
  }

  get estModeDemo(): boolean {
    return this.utilisateurServicePilotage.entiteUtilisateurSelectionnee?.estDemo || false;
  }
  private bindFiltredCtl() {
    this.groupFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtreGr();
      });

    this.orgFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtreOrg();
      });

    this.etiquetteFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtredEtq();
      });

    this.titreFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtredTitre();
      });
  }

  private filtreGr() {
    if (!this.groupes) {
      return;
    }
    let search = this.groupFilterCtrl.value;
    if (!search) {
      this.filteredGroupes.next(this.groupes.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredGroupes.next(
      this.groupes.filter(entite => entite.nom.toLowerCase().indexOf(search) > -1)
    );
  }

  private filtreOrg() {
    if (!this.organisations) {
      return;
    }
    let search = this.orgFilterCtrl.value;
    if (!search) {
      this.filteredOrganisations.next(this.organisations.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredOrganisations.next(
      this.organisations.filter(entite => entite.nom.toLowerCase().indexOf(search) > -1)
    );
  }

  private filtredEtq() {
    if (!this.etiquettes) {
      return;
    }
    let search = this.etiquetteFilterCtrl.value;
    if (!search) {
      this.filteredEtiquettes.next(this.etiquettes.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredEtiquettes.next(
      this.etiquettes.filter(etq => this.etiquetteService.getNomLocalise(etq.locales).toLowerCase().indexOf(search) > -1)
    );
  }

  private filtredTitre() {
    if (!this.titres) {
      return;
    }
    let search = this.titreFilterCtrl.value;
    if (!search) {
      this.filteredTitres.next(this.titres.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredTitres.next(
      this.titres.filter(titre => titre.toLowerCase().indexOf(search) > -1)
    );
  }


  openChoixLangueDialog(): void {
    const dialogRef = this.dialog.open(ChoixLangueCertificatDialogComponent, {
      width: '500px',
      disableClose: true,
      data: this.contenuSessionModels as ContenuSessionModel[],
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isCheckAll = false;
        this.contenuSessionModels = [];
      }
    });
  }

  paginer(event?: PageEvent) {
    if (event) {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
    }
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.contenuCertificatsAffiches = this.contenuCertificatsFiltreEnCours.slice(startIndex, endIndex);
    this.dataSource.data = this.contenuCertificatsAffiches;
    this.changeDetectorRef.detectChanges();
  }

  sortDataChange(sortState: Sort) {
    if (sortState.direction) {
      this.dataSource.sortingDataAccessor = (item: any, property: string) => {
        const value = item[property];
        if ((property === 'organisation' || property === 'groupe') && typeof value === 'object' && value !== null) {
          return StringHelpers.removeDiacritics(value.nom);
        }
        return typeof value === 'string' ? StringHelpers.removeDiacritics(value) : value;
      };
      this.dataSource.sort = this.sort;
    }
  }

  filtre(): void {
    if (this.isFiltering) return;
    this.isFiltering = true;

    try {
      this.applyFilters();

    } finally {
      this.isFiltering = false;
    }
  }

  private applyFilters(): void {
    this.contenuCertificatsFiltreEnCours = this.contenuCertificats;
    this.filtreGroupe();
    this.filtreOrganisation();
    this.filtreTitreContenus();
    this.filtreEtiquettes();
    this.filtreRecherche();
    this.totalItems = this.contenuCertificatsFiltreEnCours.length;
    this.paginer();
  }

  private updatePaginatorLength(): void {
    if (this.paginator) {
      this.paginator.length = this.contenuCertificatsFiltreEnCours.length;
      this.totalItems = this.contenuCertificatsFiltreEnCours.length;
      this.paginator.page.emit();
      this.changeDetectorRef.detectChanges();
    }
  }

  refreshDataSource(): void {
    this.contenuCertificatsFiltreEnCours = this.contenuCertificats;
    this.dataSource.data = this.contenuCertificatsFiltreEnCours;
    this.updatePaginatorLength();
  }

  reinitialiserFiltre(): void {
    this.selectionGroupe = "";
    this.selectionOrganisation = "";
    this.selectionEtiquette = "";
    this.selectionTitreContenu = "";
    this.selectionDateAcces = "last30days";
    this.textRechercher = "";
    this.applyFilters();
  }

  filtreGroupe(): void {
    let filtered = [...this.groupes];
    if (this.selectionGroupe != "") {
      this.groupeIdsSelection = this.selectionGroupe.toString().split(",");
      this.contenuCertificatsFiltreEnCours = this.contenuCertificatsFiltreEnCours.filter((contenus) => {
        if (contenus.groupe !== undefined && contenus.groupe !== null) {
          return this.groupeIdsSelection.includes(contenus.groupe.entiteId.toString())
        }
        return false;
      });
      this.dataSource = new MatTableDataSource(this.contenuCertificatsFiltreEnCours);
    } else {
      this.dataSource = new MatTableDataSource(this.contenuCertificatsFiltreEnCours);
    }
    this.filteredGroupes.next(filtered);
  }

  filtreEtiquettes(): void {
    let filtered = [...this.etiquettes];
    if (this.selectionEtiquette != "") {
      this.etiquetteIdsSelection = this.selectionEtiquette.toString().split(",")
      this.contenuCertificatsFiltreEnCours = this.contenuCertificatsFiltreEnCours.filter(contenus => {
        if (contenus.etiquettes !== undefined && contenus.etiquettes !== null && contenus.etiquettes.length > 0) {
          return this.etiquetteIdsSelection.every(e => contenus.etiquettes.some(et => e === et.etiquetteId.toString()))
        }
        return false;
      });
      this.dataSource = new MatTableDataSource(this.contenuCertificatsFiltreEnCours);
    } else {
      this.dataSource = new MatTableDataSource(this.contenuCertificatsFiltreEnCours);
    }
    this.filteredEtiquettes.next(filtered);
  }

  filtreOrganisation(): void {
    let filtered = [...this.organisations];
    if (this.selectionOrganisation != "") {
      this.organisationIdsSelection = this.selectionOrganisation.toString().split(",");
      this.contenuCertificatsFiltreEnCours = this.contenuCertificatsFiltreEnCours.filter(contenus => {
        if (contenus.organisation !== undefined && contenus.groupe !== null) {
          return this.organisationIdsSelection.includes(contenus.organisation.entiteId.toString());
        }
        return false;
      });
    } else {
      this.dataSource = new MatTableDataSource(this.contenuCertificatsFiltreEnCours);
    }
    this.filteredOrganisations.next(filtered);
  }

  filtreTitreContenus(): void {
    if (this.selectionTitreContenu != "") {
      this.contenusSelection = this.selectionTitreContenu.toString().split(",");
      this.contenuCertificatsFiltreEnCours = this.contenuCertificatsFiltreEnCours.filter(contenus => this.contenusSelection.some(e => e === contenus.titre));
      this.dataSource = new MatTableDataSource(this.contenuCertificatsFiltreEnCours);
    } else {
      this.dataSource = new MatTableDataSource(this.contenuCertificatsFiltreEnCours);
    }
  }
  filtreDateAcces(): void {
    if (this.selectionDateAcces == 'alldate') {
      this.dateDebut = this.momentDate(this.momentDate().subtract(50, 'years')).startOf('years').toDate();
      this.dateFin = this.momentDate().endOf('month').toDate();;
      this.dataSource = new MatTableDataSource(this.contenuCertificatsFiltreEnCours);
    } else if (this.selectionDateAcces == 'today') {
      this.dateDebut = this.momentDate().startOf('day').toDate();
      this.dateFin = this.momentDate().endOf('day').toDate();
      this.contenuCertificatsFiltreEnCours = this.contenuCertificatsFiltreEnCours.filter(contenu => this.momentDate(contenu.dateComplete).local().isSame(this.momentDate(), 'day'));
      this.dataSource = new MatTableDataSource(this.contenuCertificatsFiltreEnCours);
    } else if (this.selectionDateAcces == 'yesterday') {
      this.dateDebut = this.momentDate().subtract(1, 'days').startOf('day').toDate();
      this.dateFin = this.momentDate().subtract(1, 'days').endOf('day').toDate();
      this.contenuCertificatsFiltreEnCours = this.contenuCertificatsFiltreEnCours.filter(contenu => this.momentDate(contenu.dateComplete).local().isSame(this.momentDate().subtract(1, 'days'), 'day'));
      this.dataSource = new MatTableDataSource(this.contenuCertificatsFiltreEnCours);
    } else if (this.selectionDateAcces == 'week') {
      this.dateDebut = this.momentDate().subtract(6, 'days').startOf('day').toDate();
      this.dateFin = this.momentDate().endOf('day').toDate();
      this.contenuCertificatsFiltreEnCours = this.contenuCertificatsFiltreEnCours.filter(contenu => this.momentDate(contenu.dateComplete).local().isBetween(this.momentDate().subtract(6, 'days').startOf('day'), this.momentDate().endOf('day'), undefined, '[]'));
      this.dataSource = new MatTableDataSource(this.contenuCertificatsFiltreEnCours);
    } else if (this.selectionDateAcces == 'last30days') {
      this.dateDebut = this.momentDate().subtract(29, 'days').startOf('day').toDate();
      this.dateFin = this.momentDate().endOf('day').toDate();
      this.contenuCertificatsFiltreEnCours = this.contenuCertificatsFiltreEnCours.filter(contenu => this.momentDate(contenu.dateComplete).local().isBetween(this.momentDate().subtract(29, 'days').startOf('day'), this.momentDate().endOf('day'), undefined, '[]'));
      this.dataSource = new MatTableDataSource(this.contenuCertificatsFiltreEnCours);
    } else if (this.selectionDateAcces == 'year') {
      this.dateDebut = this.momentDate().startOf('years').toDate();
      this.dateFin = this.momentDate().endOf('years').toDate();
      this.contenuCertificatsFiltreEnCours = this.contenuCertificatsFiltreEnCours.filter(contenu => this.momentDate(contenu.dateComplete).local().year() === this.momentDate().year());
      this.dataSource = new MatTableDataSource(this.contenuCertificatsFiltreEnCours);
    } else if (this.selectionDateAcces == 'custom') {
      if (this.dateDebut && this.dateFin) {
        this.contenuCertificatsFiltreEnCours = this.contenuCertificatsFiltreEnCours.filter(contenu => this.momentDate(contenu.dateComplete).local().isBetween(this.momentDate(this.dateDebut).local().toDate(), this.momentDate(this.dateFin).local().toDate()));
        this.dataSource = new MatTableDataSource(this.contenuCertificatsFiltreEnCours);
      }
    }
    if (this.selectionDateAcces != '') {
      this.obtenirContenusSessionsRole();
    }
  }
  filtreRecherche(): void {
    if (this.textRechercher && this.textRechercher.length > 2) {
      const textRechercher = this.textRechercher.trim().toLowerCase();
      this.contenuCertificatsFiltreEnCours = this.contenuCertificatsFiltreEnCours.filter(contenu => {
        const checkValue = (value: any): boolean => {
          if (value && typeof value === 'object') {
            return Object.values(value).some(v => checkValue(v));
          }
          return value && String(value).toLowerCase().includes(textRechercher);
        };

        return Object.values(contenu).some(value => checkValue(value));
      });
    }
  }

  private obtenirContenusSessionsRole() {
    this.isLoading = true;
    var entiteId = this.utilisateurServicePilotage.entiteUtilisateurSelectionnee.entiteId;
    var utilisateurId = this.utilisateurServicePilotage.entiteUtilisateurSelectionnee.utilisateurId;
    var estRoot = this.utilisateurServicePilotage.selectionEntiteUtilisateur.estRoot || this.utilisateurServicePilotage.selectionEntiteUtilisateur.estRootLectureSeule;
    this.contenuSessionService.obtenirSessionsCertificatSelonRole(entiteId, utilisateurId, estRoot, this.dateDebut!, this.dateFin!).subscribe((reponse) => {
      this.contenuCertificats = reponse.filter(contenu => contenu.estDonneCertificat === true && contenu.dateComplete !== null && contenu.dateComplete !== undefined);
      this.mapperFiltres(this.contenuCertificats);
      this.applyFilters();
      this.isLoading = false;
    });
  }

  private mapperFiltres(contenusession: ContenuSessionModel[]) {
    this.groupes = Array.from(
      new Map(contenusession.map(contenu => [contenu.groupe.entiteId, contenu.groupe])).values()
    ).sort((a, b) => (a.nom ?? '').localeCompare(b.nom ?? '', 'fr', { sensitivity: 'base' }));
    this.filteredGroupes.next(this.groupes);

    const etiquettes = contenusession.map(contenu => contenu.etiquettes).flat();
    this.etiquettes = Array.from(
      new Map(etiquettes.map(etq => [this.etiquetteService.getNomLocalise(etq.locales), etq])).values()
    ).sort((a, b) =>
      this.etiquetteService.getNomLocalise(a.locales).localeCompare(
        this.etiquetteService.getNomLocalise(b.locales), 'fr', { sensitivity: 'base' }
      )
    );
    this.filteredEtiquettes.next(this.etiquettes);

    this.organisations = Array.from(
      new Map(contenusession.map(contenu => [contenu.organisation.entiteId, contenu.organisation])).values()
    ).sort((a, b) => (a.nom ?? '').localeCompare(b.nom ?? '', 'fr', { sensitivity: 'base' }));
    this.filteredOrganisations.next(this.organisations);

    this.titres = [...new Set(contenusession.map(contenu => contenu.titre))]
      .sort((a, b) => (a ?? '').localeCompare(b ?? '', 'fr', { sensitivity: 'base' }));
    this.filteredTitres.next(this.titres);
  }


  telechargerCertificatMultiple() {
    this.openChoixLangueDialog();
  }

  oncheckAll() {
    this.contenuSessionModels = [];
    if (this.isCheckAll) {
      this.contenuCertificatsFiltreEnCours.forEach(contenu => contenu.isChecked);
      this.contenuSessionModels = this.contenuCertificatsFiltreEnCours;
    }
  }

  toggleUserSelection(contenuCertif: ContenuSessionModel): void {
    contenuCertif.isChecked = !contenuCertif.isChecked;
    this.updateAllSelected();
  }

  updateAllSelected(): void {
    this.isCheckAll = this.contenuCertificatsFiltreEnCours.every(s => s.isChecked);
  }

  oncheckOne(contenuSessionModel: ContenuSessionModel) {
    if (!this.contenuSessionModels.some(contenu => contenu.id === contenuSessionModel.id && contenu.utilisateurId === contenuSessionModel.utilisateurId)) {
      this.contenuSessionModels.push(contenuSessionModel);
    } else {
      const index = this.contenuSessionModels.findIndex(contenu => contenu.id === contenuSessionModel.id && contenu.utilisateurId === contenuSessionModel.utilisateurId);
      this.contenuSessionModels.splice(index, 1)
    }
    this.isCheckAll = this.contenuSessionModels.length == this.contenuCertificatsFiltreEnCours.length;
  }

  telechargerCertificat(contenuSessionModel: ContenuSessionModel) {
    this.contenuSessionModels = [];
    this.contenuSessionModels.push(contenuSessionModel);
    this.openChoixLangueDialog();
  }

  isSelected(contenuSessionModel: ContenuSessionModel): boolean {
    return this.contenuSessionModels.some(contenu => contenu.id === contenuSessionModel.id);
  }

  private initializeDefaultDates(): void {
    if (this.selectionDateAcces === 'last30days') {
      this.dateDebut = moment().subtract(30, 'days').toDate();
      this.dateFin = moment().toDate();
    }
  }
}
